import { uniq } from 'lodash';

const human = ['form', 'entries', 'horses', 'stats'];

const jockey = [human[0], 'booked-rides', human[2], human[3]];

const course = [
    'stats',
    'course-map',
    'course-records',
    'favourites',
    'signposts',
    'course-info',
    'results',
];

export const horseSubStubs = {
    form: [
        'my-ratings',
    ],
    entries: [],
    stats: [],
    quotes: [],
    pedigree: [],
    sales: [],
    notes: [],
};

const horse = Object.keys(horseSubStubs);

const dam = uniq([
    'progeny',
    'progeny-entries',
    'progeny-sales',
    'pedigree',
    ...horse,
]);

export const sireSubTabs = {
    stallionDetails: [
        'weatherbys-overview',
        'sire-reference',
    ],
    studRecord: [
        'progeny',
        'progeny-statistics',
        'progeny-dams-sire',
        'progeny-results',
        'progeny-entries',
        'nicks',
    ],
    salesRecord: [
        'fee-history',
        'sales-statistics',
        'sales-results',
        'sales-entries',
    ],
};

const sire = uniq([
    // first 4 tabs has subtabs
    ...Object.keys(sireSubTabs),
    // no sub-tabs:
    'pedigree',
    ...horse,
]);


const TabNames = {
    owner: human,
    trainer: human,
    jockey,
    course,
    horse,
    sire,
    dam,
};

export default TabNames;



// WEBPACK FOOTER //
// ./src/js/shared/nav/helpers/tabNames.js